<template>
  <div class="flex overflow-scroll gap-4">
    <div
      v-for="language in languages"
      :key="language.lang"
      :class="{
        'border-v-300': language.value === modelValue,
        'border-n-600': language.value !== modelValue
      }"
      class="flex items-center justify-center gap-2 bg-n-700 py-2 px-4 rounded border transition-colors w-full"
      @click="select(language)"
    >
      <l-icon :name="language.icon" :original-color="true" />
      <div>
        {{ language.lang }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { LIconName } from '@last/core-ui/paprika'
import { LIcon } from '@last/core-ui/paprika'

withDefaults(
  defineProps<{
    modelValue: string
  }>(),
  {
    modelValue: ''
  }
)

const emit = defineEmits(['update:modelValue'])

type Language = {
  lang: string
  value: string
  icon: LIconName
}
const languages: Language[] = [
  {
    lang: 'ES',
    value: 'ES',
    icon: 'flags/es'
  },
  {
    lang: 'IT',
    value: 'IT',
    icon: 'flags/it'
  },
  {
    lang: 'FR',
    value: 'FR',
    icon: 'flags/fr'
  },
  {
    lang: 'EN',
    value: 'EN',
    icon: 'flags/gb'
  },
  {
    lang: 'DE',
    value: 'DE',
    icon: 'flags/de'
  }
]

function select(language: Language) {
  emit('update:modelValue', language.value)
}
</script>
